import { createStore } from "redux";
import getReducer from "./reducer.js";

//TODO actions here
let store = null;
export default function getStore(days, items, blockedDays, defaultState) {
    if (store == null) {
        store = createStore(
            getReducer(days, items, blockedDays, defaultState),
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        );
    }
    return store;
}

export function SetTerm(id, days) {
    return { type: "SETTERM", id, days }
}

export function SetDay(day, mode, value, clearPrefix=false) {
    return { type: "SETDAY", day, mode, value, clearPrefix }
}

export function SetDays(days) {
    return { type: "SETDAYS", days }
}

export function findBlockedDay(d){
    return store.getState().blockedDays.find( b => (b.from <= d && b.to >= d) );
}

export function setInsurance(insurance){
    return { type: "SETINSURANCE", insurance };
}


// WEBPACK FOOTER //
// ./flexi/store/index.js